export const ACTIVE = "Active";
export const INACTIVE = "Inactive";
export const FROZEN = "Frozen";
export const CLOSED = "ClosedByCustomer";
export const STOLEN = "Stolen";
export const LOST = "Lost";
export const SUSPECTED_FRAUD = "SuspectedFraud";

export const activeCardActions = [
  {
    name: "Close Card",
    text: "Close Card",
    value: "Close",
  },
  {
    name: "Freeze Card",
    text: "Freeze Card",
    value: "Freeze",
  },
  {
    name: "Report Lost/Stolen",
    text: "Report Lost/Stolen",
    value: "Report",
  },
];

export const inactiveActions = [
  {
    name: "Activate Card",
    text: "Activate Card",
    value: "Activate",
  },
  {
    name: "Close Card",
    text: "Close Card",
    value: "Close",
  },
];
export const frozenCardActions = [
  {
    name: "Close Card",
    text: "Close Card",
    value: "Close",
  },
  {
    name: "Report Lost/Stolen",
    text: "Report Lost/Stolen",
    value: "Report",
  },
  {
    name: "Unfreeze Card",
    text: "Unfreeze Card",
    value: "Unfreeze",
  },
];
